export default "__VITE_ASSET__Bg9C3lAk__"